import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import jwtDecode from 'jwt-decode';
import { NEW_RELIC_SCRIPT } from '@/store/modules/script/types';
import { ABTASTY_URL, GOOGLE_SITE_VERIFICATION, NORTON_SAFEWEB_SITE_VERIFICATION, TRUSTED_SHOP_URL, SPEEDCURVE_URL } from '~/const/3rd';
import { FAST_TIMER } from '~/const/timers';
import logout from '~/helpers/logout-helper';
import USE_MERCURE from '~/const/mercure';
import isValidToken from '~/helpers/connection-helper';
import parseHash from '~/helpers/auth-helpers';
import Notifications from '~/mixins/Notifications';
import TheFooter from '~/components/specific/TheFooter/TheFooter.vue';

var MainHeader = function MainHeader() {
  return import('~/components/specific/MainHeader/MainHeader.vue');
};

var MdmLayer = function MdmLayer() {
  return import(
  /* webpackChunkName: "common-default" */
  '~/components/atoms/Global/MdmLayer.vue');
};

var MdmBackToTop = function MdmBackToTop() {
  return import(
  /* webpackChunkName: "common-default" */
  '~/components/atoms/Global/MdmBackToTop.vue');
};

var SkipLinks = function SkipLinks() {
  return import(
  /* webpackChunkName: "common-default" */
  '~/components/molecules/Global/Skiplinks.vue');
};

export default {
  components: {
    MainHeader: MainHeader,
    TheFooter: TheFooter,
    MdmBackToTop: MdmBackToTop,
    SkipLinks: SkipLinks
  },
  mixins: [Notifications],
  data: function data() {
    return {
      mdmLayer: null,
      tp: true,
      tcVars: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    tracking: 'sharedEnv/tracking',
    user: 'user/me'
  })), {}, {
    containsQuery: function containsQuery() {
      var noIndex = {
        name: 'robots',
        content: 'noindex'
      };
      return this.isSearchQueryAlgolia ? noIndex : {};
    },
    speedcurveConfig: function speedcurveConfig() {
      var luxConfig = {
        innerHTML: 'LUX=(function(){var a=("undefined"!==typeof(LUX)&&"undefined"!==typeof(LUX.gaMarks)?LUX.gaMarks:[]);var d=("undefined"!==typeof(LUX)&&"undefined"!==typeof(LUX.gaMeasures)?LUX.gaMeasures:[]);var h="LUX_start";var j=window.performance;var k=("undefined"!==typeof(LUX)&&LUX.ns?LUX.ns:(Date.now?Date.now():+(new Date())));if(j&&j.timing&&j.timing.navigationStart){k=j.timing.navigationStart}function e(){if(j){if(j.now){return j.now()}else{if(j.webkitNow){return j.now()}else{if(j.msNow){return j.now()}else{if(j.mozNow){return j.now()}}}}}var m=Date.now?Date.now():+(new Date());return m-k}function b(m){if(j){if(j.mark){return j.mark(m)}else{if(j.webkitMark){return j.webkitMark(m)}}}a.push({name:m,entryType:"mark",startTime:e(),duration:0});return}function l(o,s,m){if("undefined"===typeof(s)&&g(h)){s=h}if(j){if(j.measure){if(s){if(m){return j.measure(o,s,m)}else{return j.measure(o,s)}}else{return j.measure(o)}}else{if(j.webkitMeasure){return j.webkitMeasure(o,s,m)}}}var q=0,n=e();if(s){var r=g(s);if(r){q=r.startTime}else{if(j&&j.timing&&j.timing[s]){q=j.timing[s]-j.timing.navigationStart}else{return}}}if(m){var p=g(m);if(p){n=p.startTime}else{if(j&&j.timing&&j.timing[m]){n=j.timing[m]-j.timing.navigationStart}else{return}}}d.push({name:o,entryType:"measure",startTime:q,duration:(n-q)});return}function g(m){return c(m,f())}function c(p,o){for(i=o.length-1;i>=0;i--){var n=o[i];if(p===n.name){return n}}return undefined}function f(){if(j){if(j.getEntriesByType){return j.getEntriesByType("mark")}else{if(j.webkitGetEntriesByType){return j.webkitGetEntriesByType("mark")}}}return a}return{mark:b,measure:l,gaMarks:a,gaMeasures:d}})();LUX.ns=(Date.now?Date.now():+(new Date()));LUX.ac=[];LUX.cmd=function(a){LUX.ac.push(a)};LUX.samplerate = 10;'
      };
      return luxConfig;
    },
    preconnectDomains: function preconnectDomains() {
      return [{
        rel: 'preconnect',
        href: 'https://fonts.gstatic.com/',
        crossorigin: true
      }, {
        rel: 'dns-prefetch',
        href: '//fonts.googleapis.com'
      }];
    },
    newRelicScript: function newRelicScript() {
      var newRelicScript = this.$store.getters[NEW_RELIC_SCRIPT];

      if (newRelicScript === '' || !newRelicScript) {
        return false;
      }

      return {
        innerHTML: newRelicScript
      };
    },
    tcVarsScript: function tcVarsScript() {
      if (process.client || !Object.keys(this.tcVars).length) {
        return false;
      }

      return {
        innerHTML: "window.tc_vars = ".concat(JSON.stringify(this.tcVars), ";"),
        body: true
      };
    },
    searchInsights: function searchInsights() {
      if (!this.$cookies.get('algolia')) {
        return false;
      }

      var _this$$store$state$sh = this.$store.state.sharedEnv.payload.algolia,
          algoliaApplicationID = _this$$store$state$sh.applicationId,
          algoliaApiKey = _this$$store$state$sh.apiKey;
      return {
        innerHTML: "\n          var ALGOLIA_INSIGHTS_SRC = \"https://cdn.jsdelivr.net/npm/search-insights@1.3.0\";\n\n          !function(e,a,t,n,s,i,c){e.AlgoliaAnalyticsObject=s,e.aa=e.aa||function(){\n          (e.aa.queue=e.aa.queue||[]).push(arguments)},i=a.createElement(t),c=a.getElementsByTagName(t)[0],\n          i.async=1,i.src=ALGOLIA_INSIGHTS_SRC,c.parentNode.insertBefore(i,c)\n          }(window,document,\"script\",0,\"aa\");\n\n          aa('init', {\n            appId: '".concat(algoliaApplicationID, "',\n            apiKey: '").concat(algoliaApiKey, "',\n          });\n        "),
        body: true
      };
    },
    tagCo: function tagCo() {
      if (!process.server || this.tp === false) {
        return false;
      }

      return {
        innerHTML: "\n          window.addEventListener(\"load\", function(){\n            var script = document.createElement('script');\n            var s = document.getElementsByTagName('script')[0];\n            script.type = 'text/javascript';\n            script.async = true;\n            script.onload = function() {\n              window.setTimeout(function() {\n                if(!window.mdm_events) { return; }\n                var tags = window.mdm_events_pending || [];\n                for(var i=0; i<tags.length; i++) {\n                  if(/(^|;\\s?)debugmdm=/.test(document.cookie)) {\n                    console.log('pending tracking', tags[i]);\n                  }\n                  window.mdm_events(".concat(this.tracking.id, ", tags[i].event, tags[i].data.fn || 'track-event', tags[i].data.data);\n                }\n                window.mdm_events_pending = [];\n              }, 0);\n              window.isTcContainerLoadedBefore = true;\n              if(/(^|;\\s?)debugmdm=/.test(document.cookie)) {\n                console.log('tc_container is loaded');\n              }\n            };\n            script.src = '").concat(this.tracking.container, "?").concat(Math.floor(Date.now() / 1000), "';\n            s.parentNode.insertBefore(script, s);\n          }, { passive: true });"),
        body: true
      };
    },
    safariFix: function safariFix() {
      if (!process.server) {
        return false;
      }

      return {
        innerHTML: '!function(){var e=document,t=e.createElement("script");if(!("noModule"in t)&&"onbeforeload"in t){var n=!1;e.addEventListener("beforeload",function(e){if(e.target===t)n=!0;else if(!e.target.hasAttribute("nomodule")||!n)return;e.preventDefault()},!0),t.type="module",t.src=".",e.head.appendChild(t),t.remove()}}();'
      };
    },
    isSearchQueryAlgolia: function isSearchQueryAlgolia() {
      return this.$route.query.query;
    }
  }),
  created: function created() {
    var _this = this;

    if ('nothirdparties' in this.$route.query) {
      this.tp = false;
    }

    if (process.client) {
      var _this$$route$query = this.$route.query,
          _this$$route$query$ut = _this$$route$query.utm_source,
          utmSource = _this$$route$query$ut === void 0 ? '' : _this$$route$query$ut,
          _this$$route$query$ut2 = _this$$route$query.utm_medium,
          utmMedium = _this$$route$query$ut2 === void 0 ? '' : _this$$route$query$ut2,
          _this$$route$query$ut3 = _this$$route$query.utm_campaign,
          utmCampaign = _this$$route$query$ut3 === void 0 ? '' : _this$$route$query$ut3,
          _this$$route$query$ut4 = _this$$route$query.utm_content,
          utmContent = _this$$route$query$ut4 === void 0 ? '' : _this$$route$query$ut4,
          _this$$route$query$gc = _this$$route$query.gclid,
          gclid = _this$$route$query$gc === void 0 ? '' : _this$$route$query$gc;
      this.$nextTick(function () {
        var mdmSourceContent;
        if (gclid) mdmSourceContent = "gclid=".concat(gclid);else if (utmSource || utmMedium || utmCampaign || utmContent) mdmSourceContent = "utm_source=".concat(utmSource, "|utm_medium=").concat(utmMedium, "|utm_campaign=").concat(utmCampaign, "|utm_content=").concat(utmContent);

        if (mdmSourceContent) {
          _this.$cookies.set('MDM_SOURCE', mdmSourceContent, {
            path: '/',
            maxAge: 3600 * 24 * 365
          });
        }
      });
      var decoded = localStorage.getItem('MDM_ACCESS_TOKEN') ? jwtDecode(localStorage.getItem('MDM_ACCESS_TOKEN')) : '';

      if (USE_MERCURE(this.locale.iso) && localStorage.getItem('MDM_ACCESS_TOKEN') && decoded.aud !== 'mercure' || !USE_MERCURE(this.locale.iso) && localStorage.getItem('MDM_ACCESS_TOKEN') && decoded.aud === 'mercure') {
        logout();
      }
    }

    this.$root.$on('updated-tcvars', this.onUpdateTcVars);
    this.$root.$on('on-tc-hit-blocker', this.onTcHitBlocker);
    this.$root.$on('user-login-success', this.updateUserAndCart);
    this.$root.$on('user-signup-success', this.fetchUser);
  },
  mounted: function mounted() {
    var _this2 = this;

    if (isValidToken()) {
      this.fetchUser().then(function () {
        if (_this2.user && _this2.user.intercomHash) {
          window.mdm_user_intercom_hash = _this2.user.intercomHash;
        }

        if (_this2.user && _this2.user.email) {
          window.mdm_user_intercom_email = _this2.user.email;
        }

        setTimeout(function () {
          _this2.$root.$emit('reset-tcvars');
        }, FAST_TIMER);
      }).catch(function (err) {
        _this2.$logger.error(err);
      });
    }

    window.history.scrollRestoration = 'auto';
    window.addEventListener('load', this.onLoad, {
      passive: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('load', this.onLoad);
    this.$root.$off('updated-tcvars');
    this.$root.$off('on-tc-hit-blocker');
    this.$root.$off('generic-tracking');
    this.$root.$off('user-login-success');
    this.$root.$off('user-signup-success');
  },
  methods: _objectSpread(_objectSpread({}, mapActions({
    fetchUser: 'user/fetchUser',
    fetchWishlist: 'wishlist/fetchWishlistItems',
    fetchCart: 'cart/fetchCart',
    createCart: 'cart/createCart'
  })), {}, {
    onLoad: function onLoad() {
      var _this3 = this;

      if (process.env.NODE_ENV === 'production') {
        this.abTasty();
        this.lux();
        this.trustedShop();
      }

      this.fetchCart().catch(function (err) {
        _this3.$logger.error(err);
      });

      if (isValidToken()) {
        this.fetchWishlist().catch(function (err) {
          _this3.$logger.error(err);
        });
      }

      this.$root.$on('generic-tracking', this.onTracking);
      this.lazyloadComponents();

      if (this.isSearchQueryAlgolia) {
        this.$root.$emit('open-algolia-search');
      }

      if (this.$route.hash) {
        this.connectAs();
      }
    },
    connectAs: function connectAs() {
      var _this4 = this;

      var _parseHash = parseHash(this.$route.hash.slice(1)),
          token = _parseHash.drc_token,
          connectAs = _parseHash.drc_redirect,
          seller = _parseHash.seller_id;

      if (connectAs) {
        var decoded = jwtDecode(token);
        localStorage.setItem('MDM_ACCESS_TOKEN', token);
        localStorage.setItem('MDM_ACCESS_TOKEN_EXPIRES_AT', decoded.exp * 1000);
        localStorage.setItem('MDM_CONNECT_AS', connectAs);
        localStorage.setItem('MDM_SELLER_ID', seller);
        this.createCart().then(function () {
          window.location.href = _this4.$route.path;
        });
      }
    },
    updateUserAndCart: function updateUserAndCart() {
      this.fetchUser();
      this.updateCart();
    },
    updateCart: function updateCart() {
      var _this5 = this;

      this.fetchCart().catch(function (err) {
        _this5.$logger.error(err);
      });
    },
    onUpdateTcVars: function onUpdateTcVars(tcVars) {
      this.tcVars = tcVars;

      if (process.client && 'init' in window.LUX) {
        window.LUX.init();
      }

      if (process.client && Object.keys(this.tcVars).length) {
        if (this.$cookies.get('debugmdm')) {
          console.log('inject Tcvars', _objectSpread({}, this.tcVars));
        }

        window.tc_vars = _objectSpread({}, this.tcVars);

        if (window.tC) {
          window.tC.container.reload();
          window.tC.event.reload();

          if (this.$cookies.get('debugmdm')) {
            console.log('container.reload() and event.reload()');
          }
        }
      }
    },
    onTcHitBlocker: function onTcHitBlocker(tcVars) {
      this.tcVars = tcVars;
      window.tc_vars = _objectSpread({}, this.tcVars);

      if (this.$cookies.get('debugmdm')) {
        console.log('onTcHitBlocker:', _objectSpread({}, window.tc_vars));
      }
    },
    onTracking: function onTracking(el, payload) {
      if (process.client && this.$cookies.get('debugmdm')) {
        this.$logger.debug('generic tracking', {
          el: el,
          payload: payload
        });
      }

      if (window.mdm_events) {
        window.mdm_events(this.tracking.id, el, payload.fn || 'track-event', payload.data);
      }
    },
    abTasty: function abTasty() {
      var _this6 = this;

      if (this.tp === false) {
        return;
      }

      window.LUX.mark('before ABTasty');
      this.asyncScript(ABTASTY_URL).catch(function (err) {
        _this6.$logger.error('ABTASTY FAILED', err);
      });
    },
    trustedShop: function trustedShop() {
      var _this7 = this;

      if (this.tp === false) {
        return;
      }

      if (this.locale.market === 'DE') {
        this.asyncScript(TRUSTED_SHOP_URL).catch(function (err) {
          _this7.$logger.error('TRUSTEDSHOP FAILED', err);
        });
      }
    },
    lux: function lux() {
      var _this8 = this;

      window.LUX.mark('before LUX');
      this.asyncScript(SPEEDCURVE_URL).catch(function (err) {
        _this8.$logger.error('LUX FAILED', err);
      });
    },
    lazyloadComponents: function lazyloadComponents() {
      this.mdmLayer = MdmLayer;
    }
  }),
  head: function head() {
    return {
      __dangerouslyDisableSanitizers: ['script'],
      script: [this.newRelicScript, this.tcVarsScript, this.speedcurveConfig, this.tagCo, this.safariFix, this.searchInsights],
      meta: [{
        hid: 'robots',
        name: 'robots',
        content: 'noodp'
      }, {
        name: 'google-site-verification',
        content: GOOGLE_SITE_VERIFICATION
      }, {
        name: 'norton-safeweb-site-verification',
        content: NORTON_SAFEWEB_SITE_VERIFICATION
      }, {
        name: 'theme-color',
        content: '#3C3C3B'
      }, this.containsQuery],
      link: _toConsumableArray(this.preconnectDomains),
      htmlAttrs: {
        lang: this.locale.language
      }
    };
  }
};